export const GUEST_LIST_HREF = '/wedding/onboard/wedding-guest-list';
export const SAVE_THE_DATE_HREF =
  '/wedding-planning/save-the-date/shop?multi_sample_mode=multisampleenabled';
export const WEDDING_WEBSITE_HREF = '/wedding/manage/website/designs';
